import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoPipe } from '@ngneat/transloco';
import { Subject, of } from 'rxjs';
import { switchMap, takeUntil } from 'rxjs/operators';
import { SubscriptionService } from 'app/modules/partner/services/subscription.service';
import { UserService } from 'app/core/user/user.service';
import { UpgradeService } from 'app/modules/shared/services/upgrade.service';

@Component({
    selector: 'plan-limit-top-bar',
    templateUrl: './plan-limit-top-bar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        TranslocoPipe
    ]
})
export class PlanLimitTopBarComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    visible: boolean = false;
    dismissed: boolean = false;
    excessCount: number = 0;
    dishLimit: number = 0;
    /** True when exactly at limit (not over) */
    atLimit: boolean = false;

    constructor(
        private _subscriptionService: SubscriptionService,
        private _userService: UserService,
        private _upgradeService: UpgradeService,
        private _cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this._userService.user$
            .pipe(
                takeUntil(this._unsubscribeAll),
                switchMap(user => {
                    if (!user?.partnerId) {
                        return of(null);
                    }
                    return this._subscriptionService.getUsage(user.partnerId);
                })
            )
            .subscribe(usage => {
                if (!usage) {
                    this.visible = false;
                    this._cdr.markForCheck();
                    return;
                }

                const dishCount = usage.dishCount ?? 0;
                const limit = usage.dishLimit ?? 0;

                if (limit > 0 && limit !== Infinity && dishCount >= limit) {
                    this.visible = true;
                    this.excessCount = dishCount - limit;
                    this.dishLimit = limit;
                    this.atLimit = dishCount === limit;
                } else {
                    this.visible = false;
                }

                this._cdr.markForCheck();
            });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    dismiss(): void {
        this.dismissed = true;
        this._cdr.markForCheck();
    }

    openUpgradeDialog(): void {
        this._upgradeService.openUpgradeModal();
    }
}
